import { useAuth } from "../../../modules/auth/authHooks";
import { ResponsivePresetKeys, ResponsivePresets } from "../../../modules/configs/responsiveImageConfigs";
import ImageGenerator from "../../shared/imageGenerator/ImageGenerator";
import * as styles from "./styles.module.scss";

const ProfileImage = () => {
  const auth = useAuth();

  return (
    <div className={styles.sidebarProfileContainer}>
      <div className={styles.sidebarProfileImage}>
        <ImageGenerator
          src={auth.user.ap.avatar}
          imageType="square"
          sizes={ResponsivePresets[ResponsivePresetKeys.BOTTOM_NAVIGATION_PROFILE]}
        />
      </div>
      <span>{auth.user.ap.name}</span>
    </div>
  );
};

export default ProfileImage;
